import ScrollReveal from '@/components/base/ScrollReveal';

export default function IntroSection() {
  return (
    <section id="about" className="relative py-32 md:py-44 lg:py-52 px-6 md:px-10 lg:px-16 bg-background-50 overflow-hidden scroll-mt-20 min-h-[80vh] flex items-center">
      {/* Background image — subtle data mesh */}
      <div className="absolute inset-0 opacity-[0.03]">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20technological%20data%20mesh%20topology%20with%20interconnected%20luminous%20nodes%20and%20delicate%20threads%20forming%20a%20subtle%20network%20across%20a%20near%20black%20canvas%2C%20prominent%20emerald%20green%20and%20teal%20micro%20nodes%20scattered%20like%20digital%20constellations%20with%20gentle%20green%20luminescence%2C%20warm%20amber%20and%20soft%20green%20accents%20weaving%20through%20the%20network%20threads%2C%20ethereal%20minimalist%20atmosphere%20suggesting%20distributed%20computing%20and%20data%20flow%2C%20very%20dark%20background%20with%20barely%20visible%20ambient%20highlights%2C%20ultra%20subtle%20and%20elegant%20composition%20designed%20for%20text%20overlay%2C%20sophisticated%20informational%20aesthetic%2C%20clean%20modern%20minimal%20design%2C%20negative%20space%20dominant%20with%20occasional%20green%20sparkling%20nodes%2C%20subtle%20green%20data%20current%20flow%20suggestion&width=1600&height=1000&seq=intro-bg-v3&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Animated horizontal data lines */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[28%] left-0 w-full h-px bg-gradient-to-r from-transparent via-accent-500/12 to-transparent" />
        <div className="absolute top-[58%] left-0 w-full h-px bg-gradient-to-r from-transparent via-accent-500/8 to-transparent" />
      </div>

      {/* Gradient overlays for seamless blend */}
      <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-transparent to-background-50 pointer-events-none" />

      {/* Subtle floating orbs */}
      <div className="absolute top-[15%] left-[8%] w-[320px] h-[320px] rounded-full bg-accent-500/3 blur-[120px] orb-float pointer-events-none" />
      <div className="absolute bottom-[20%] right-[5%] w-[260px] h-[260px] rounded-full bg-primary-400/2 blur-[100px] orb-float-slow pointer-events-none" />

      {/* Content — clean centered editorial */}
      <div className="relative z-10 w-full max-w-4xl mx-auto text-center">

        {/* Pre-title — About DATAi */}
        <ScrollReveal delay={150} duration={500}>
          <p className="mb-5 md:mb-6">
            <span className="text-xs md:text-sm font-medium tracking-[0.25em] uppercase text-accent-600">About</span>{' '}
            <span className="font-heading font-bold tracking-tight text-primary-800 text-sm md:text-base">DATA<span className="text-accent-500">i</span></span>
          </p>
        </ScrollReveal>

        {/* Statement 1 */}
        <ScrollReveal delay={300} duration={600}>
          <p className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-primary-800 leading-[1.16] tracking-tight mb-10 md:mb-14 max-w-3xl mx-auto">
            Most systems just store and move data. We build platforms that{' '}
            <span className="text-accent-500">put data to work.</span>
          </p>
        </ScrollReveal>

        {/* Thin accent divider */}
        <ScrollReveal delay={450} duration={400}>
          <div className="mx-auto w-12 h-px bg-accent-500/15 mb-10 md:mb-14" />
        </ScrollReveal>

        {/* Narrative body — clean unified tone, no mixed colors */}
        <ScrollReveal delay={550} duration={600}>
          <p className="text-lg md:text-xl lg:text-2xl text-foreground-500 font-light leading-[1.7] max-w-2xl mx-auto">
            Working with clients of any size and sector, we design, build and ship software, AI and data systems that turn raw information into decisions your business can act on.
          </p>
        </ScrollReveal>

        {/* Final accent line */}
        <ScrollReveal delay={750} duration={400}>
          <div className="mx-auto w-10 h-px bg-accent-500/12 mt-14 md:mt-18" />
        </ScrollReveal>

      </div>
    </section>
  );
}